import service from "@irati-tracking/tracker"

class MySavingsTrackingEvents {
  clickSavingsTrackerBtn = (source: string, perkbox_product: string, type: string) => {
    service.trackCTAEvent({
      source,
      type,
      perkbox_product
    })
  }

  clickSavingsCalculatorBtn = (perkbox_product: string, type: any) => {
    const {brand, amount} = type

    service.trackCTAEvent({
      source: "savings_calculator",
      type: `${brand} | ${amount}`,
      perkbox_product
    })
  }
}

export default new MySavingsTrackingEvents()
